import React from 'react';
import './index.scss'
import { getAssetsImages } from '@/utils/tools';

const Copyright = () => {
  return (
    <div className="copyright">
      <span>啄木鸟网络科技提供技术支持</span>
      <a href='https://beian.mps.gov.cn/#/query/webSearch' className='footer-link' target='_blank'>
        <img src={getAssetsImages('police.png')} alt="" />
        渝公网安备50019002504602号
      </a>
      <a href='https://beian.miit.gov.cn/#/Integrated/index' target='_blank'>渝ICP备2024044452号-1</a>
    </div>
  );
};

export default Copyright;
